import xeroLogo from "@/assets/xero-logo.png";
import sageLogo from "@/assets/sage-logo.png";
import saicaBadge from "@/assets/saica-badge.png";
import sarsLogo from "@/assets/sars-logo.png";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";

const partners = [
  { name: "Xero", logo: xeroLogo, size: "h-16 md:h-20" },
  { name: "Sage Pastel", logo: sageLogo, size: "h-12 md:h-14" },
  { name: "SAICA", logo: saicaBadge, size: "h-14 md:h-16" },
  { name: "SARS", logo: sarsLogo, size: "h-16 md:h-20" },
];

export function PartnersBanner() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-12 lg:py-16 bg-gradient-to-b from-muted to-background border-b border-border">
      <div className="container mx-auto px-4">
        <p className="text-center text-sm font-medium text-muted-foreground uppercase tracking-wider mb-3">
          {"\n"}
        </p>
        <p className="text-center text-base text-foreground/80 mb-8 max-w-2xl mx-auto">
          {"\n"}
        </p>
        <div
          ref={ref}
          className="flex flex-wrap justify-center items-center gap-12 md:gap-20 max-w-4xl mx-auto reveal-stagger"
        >
          {partners.map((partner) => (
            <div
              key={partner.name}
              className={`flex items-center justify-center scroll-reveal-scale ${isVisible ? "revealed" : ""} hover:scale-105 transition-all duration-500`}
            >
              <img
                src={partner.logo}
                alt={`${partner.name} logo`}
                className={`${partner.size} w-auto object-contain`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
        {/* Decorative line */}
        <div className="mt-10 max-w-xs mx-auto h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      </div>
    </section>
  );
}
